/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Credit transaction status
 */
export type GetUserCreditAccountTransactionsForAppResponseDataItemStatus = typeof GetUserCreditAccountTransactionsForAppResponseDataItemStatus[keyof typeof GetUserCreditAccountTransactionsForAppResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserCreditAccountTransactionsForAppResponseDataItemStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  VOID: 'VOID',
  DECLINED: 'DECLINED',
} as const;
